import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Peter Noble
 * id DFE8FD81-B967-4E07-A1C9-44A608613E26
 * name menu-right-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/menu-right-outline.svg
 * tags
 */
export const MenuRightOutlineIcon = createSvgIcon(<><path d="M9,6H10.5L16.5,12L10.5,18H9V6M13.67,12L11,9.33V14.67L13.67,12Z" /></>, 'MenuRightOutlineIcon');
export default MenuRightOutlineIcon